/* unplugin-vue-components disabled */import { render } from "./files.vue?vue&type=template&id=71e86985&scoped=true"
import script from "./files.vue?vue&type=script&setup=true&lang=js"
export * from "./files.vue?vue&type=script&setup=true&lang=js"

import "./files.vue?vue&type=style&index=0&id=71e86985&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e86985"],['__file',"src/pages/tenants/files/files.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71e86985"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71e86985', __exports__)) {
    api.reload('71e86985', __exports__)
  }
  
  module.hot.accept("./files.vue?vue&type=template&id=71e86985&scoped=true", () => {
    api.rerender('71e86985', render)
  })

}


export default __exports__